import { render, staticRenderFns } from "./KmPercorridoColeta.vue?vue&type=template&id=5190d537&scoped=true&"
import script from "./KmPercorridoColeta.vue?vue&type=script&lang=js&"
export * from "./KmPercorridoColeta.vue?vue&type=script&lang=js&"
import style0 from "./KmPercorridoColeta.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./KmPercorridoColeta.vue?vue&type=style&index=1&id=5190d537&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5190d537",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
